import React from "react";
import { PageHeader, Button, Icon, Col, Row } from "antd";


export default function Header(props) {
  return (
    <PageHeader
      title={
        <div>
          <Icon type="container" />
          &nbsp;&nbsp;<span>{props.title}</span>
        </div>
      }
      extra={[
        <div key="1">
  
          {props.onReturn === undefined ? null : (
            <Button
              icon="left-circle"
              type="success"
              hidden={props.isRegresar}
              onClick={props.onReturn}
            >
              Regresar
            </Button>
          )}

          {props.isPagar === true ?

            <Button icon="credit-card" type="primary"  onClick={props.onPagar} className="ml-10">
              Pagar
            </Button>

            : null
            }

          {props.onSearch === undefined ? null : (
            <Button icon="search" type="primary" ghost onClick={props.onSearch} className="ml-10">
              Buscar
            </Button>
          )}

          {props.onClearFilters === undefined ? null : (
            <Button icon="shake" type="primary" ghost onClick={props.onClearFilters} className="ml-10">
              Limpiar
            </Button>
          )}
        </div>,
      ]}
    ></PageHeader>
  );
}
